import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import exact from 'prop-types-exact'
import { Link } from 'react-router'
import { pure } from 'recompose'
import {
  SCHOOL_PORTAL_ROUTE,
  EDUCATOR_PORTAL_ROUTE,
  LEARNING_HUB_ROUTE,
} from 'config'
import schoolPortal from 'images/communities/Chicago/Educator/school-portal.png'
import educatorPortal from 'images/communities/Chicago/Educator/educator-portal.png'
import learningHubPortal from 'images/communities/Chicago/learning-hub/learning-hub.svg'
import classnames from 'classnames'
import { get } from 'lodash'
import { useCommunity, isSchoolPortalEnabled, isEducatorEnabled } from 'utils'

const propTypes = {
  currentPortal: Types.portalType.isRequired,
  currentEmployment: Types.employer,
  learningHubAccess: PropTypes.bool,
}

const defaultProps = {
  currentEmployment: null,
  learningHubAccess: false,
}

function PortalSelector({
  currentPortal,
  currentEmployment,
  learningHubAccess,
}) {
  const community = useCommunity()
  const position = get(currentEmployment, 'position')
  const hasSchoolAccess =
    isSchoolPortalEnabled(community) && position != Types.POSITION_TYPES.TEACHER
  const hasEducatorAccess =
    isEducatorEnabled(community) && position != Types.POSITION_TYPES.PRINCIPAL

  return (
    <nav className="portal-select" aria-label="Portal select">
      <ul>
        {hasSchoolAccess && (
          <li>
            <Link
              to={SCHOOL_PORTAL_ROUTE}
              className={classnames({
                'selected-portal': currentPortal === Types.PORTAL.SCHOOL_PORTAL,
              })}
            >
              <img src={schoolPortal} alt="" />
              School
            </Link>
          </li>
        )}
        {hasEducatorAccess && (
          <li>
            <Link
              to={EDUCATOR_PORTAL_ROUTE}
              className={classnames({
                'selected-portal':
                  currentPortal === Types.PORTAL.EDUCATOR_PORTAL,
              })}
            >
              <img src={educatorPortal} alt="" />
              Educator
            </Link>
          </li>
        )}
        {learningHubAccess && (
          <li>
            <Link
              to={LEARNING_HUB_ROUTE}
              className={classnames({
                'selected-portal': currentPortal === Types.PORTAL.LEARNING_HUB,
              })}
            >
              <img src={learningHubPortal} alt="" />
              Learning Hub
            </Link>
          </li>
        )}
      </ul>
    </nav>
  )
}

PortalSelector.propTypes = exact(propTypes)
PortalSelector.defaultProps = defaultProps

export default pure(PortalSelector)
